/**
 * isMockDataUM — controls whether the University Manager section uses mock data or real API.
 * Set to true  → all UM pages use mock data (demo mode).
 * Set to false → all UM pages call the real backend (/university-admin/* endpoints).
 *
 * Operations that have no corresponding backend endpoint always fall back to mock regardless.
 */
export const isMockDataUM = false;
